module.exports = __webpack_public_path__ + "static/media/liquid_22_detail_01.94a72e18.jpg";